import { FC } from 'react';
import { BeatLoader } from 'react-spinners';
import { strings } from '@/constants/strings';
import { Call } from '@/types/call';
import { CallsListItem } from './calls-list-item';

export type CallListProps = {
  calls: Call[];
  loading?: boolean;
};

export const CallList: FC<CallListProps> = ({ calls, loading }) => (
  <div className="flex max-w-[30rem] flex-col px-6">
    {loading ? (
      <BeatLoader />
    ) : calls.length > 0 ? (
      calls.map((call, index) => (
        <CallsListItem
          call={call}
          isLast={index === calls.length - 1}
          key={index}
        />
      ))
    ) : (
      <div className="text-xs italic text-gray-500">{strings.calls.empty}</div>
    )}
  </div>
);
